export interface AccessRight {
	arrears_reports: boolean,
	clergy_compensation_report: boolean,
	lay_compensation_report: boolean,
	imputed_income_reports: boolean,
	institutions_list: boolean,
	ir_summary_pension_medial_enrollment: boolean,
	employee_list: boolean,
	er_employee_pension_medial_enrollment: boolean,
}

export interface AccessObject {
	diocese: string,
	client_number: string,
	reports_access: AccessRight,
}
export interface ReportAccess {
	available_diocese: AccessObject[],
	available_institutions: AccessObject[],
}

export interface ReportAccessState {
	accessRights: ReportAccess,
	accessRightsLoaded: boolean,
}

export enum ReportAccessActions {
	SET_ACCESS_RIGHT = 'SET_ACCESS_RIGHT',
}